
enum  ReviewStateState {
	UNANSWERED = 'UNANSWERED',
	ANSWERED = 'ANSWERED'
}

export default  ReviewStateState
